import { Color, InspirationalImage, config } from '@thisisdevelopment/akzonobel-core';
import COLOURS_INFO from '@/pages/ColorDetails/colorsInfo.json';

const getColorEnrichment = (cccid: number) => {
  const enrichment = COLOURS_INFO.find((item) => item.cccid === cccid);
  return enrichment
    ? {
        description: enrichment.description,
        cccid: enrichment.cccid,
      }
    : {};
};

export const shuffleArray = (array: any[]): any[] => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const getInspirationalImages = (cccid: number): InspirationalImage[] => {
  const baseUrl = `https://s3-eu-west-1.amazonaws.com/aats3-${config.domainCode}-prod-1dcdb-public/inspirational`;
  const places = ['hallway', 'living-room', 'dining-room', 'office', 'bedroom'];
  return places.map((place) => ({
    url: `${baseUrl}/${cccid}-${place}.jpg`,
    thumbnail: `${baseUrl}/thumb/${cccid}-${place}.jpg`,
    colorCollectionColorId: cccid,
    roomTypes: {
      global: place.replace('-', ' '),
      localized: place.replace('-', ' '),
    },
  }));
};

export interface HydratedColor extends Color {
  description?: string;
  videoId?: number;
  coverId?: number;
  inspirationalImages?: InspirationalImage[];
}

export const hydrateColor = (color: Color): HydratedColor => ({
  ...color,
  inspirationalImages: getInspirationalImages(color.colorCollectionColorId),
  ...getColorEnrichment(color.colorCollectionColorId),
});
